const SOURCE_COMMENT_WIKI_PATH = /<!--\s*source:.*?\bwiki_path:\s*([\s\S]*?)\s*-->/i;

export function sourceDisplayName(name: string | undefined, content?: string): string | undefined {
  const sourcePath = content ? wikiPathFromSourceComment(content) : undefined;
  if (sourcePath) return basename(sourcePath);
  if (!name) return undefined;

  return basename(name);
}

function wikiPathFromSourceComment(content: string): string | undefined {
  const rawPath = SOURCE_COMMENT_WIKI_PATH.exec(content)?.[1]?.trim();
  if (!rawPath) return undefined;

  return safeDecodeURIComponent(rawPath.replace(/\+/g, '%20'));
}

function basename(value: string): string {
  const normalized = safeDecodeURIComponent(value)
    .replace(/\\/g, '/')
    .replace(/[?#].*$/, '');
  const slashName = normalized.split('/').filter(Boolean).at(-1) ?? normalized;
  return slashName.split('__').filter(Boolean).at(-1) ?? slashName;
}

function safeDecodeURIComponent(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}
